export const site = {
    name: "NS Tømrer og Ejendomsservice",
    shortName: "NS Tømrer",
    owner: "Nicklas Sørensen",
    city: "Silkeborg",
    area: "Silkeborg og omegn",
    phone: "29 88 04 52",
    phoneHref: "tel:+4529880452",
    email: "nstomrer@gmail.com",
    emailHref: "mailto:nstomrer@gmail.com",
    facebookUrl: "https://www.facebook.com/nstomrer",
    facebookLabel: "NS Tømrer på Facebook",
    instagramUrl: "https://www.instagram.com/ns_tomrer_ejendomsservive/",
    instagramLabel: "NS Tømrer på Instagram",
    instagramHandle: "@ns_tomrer_ejendomsservive",
    tagline: "Din lokale tømrer i Silkeborg og omegn",
    headline: "Ordentligt håndværk du kan stole på",
    subline:
        "Jeg Nicklas Sørensen kommer gerne ud, tager en snak og giver et helt uforpligtende tilbud.",
    shortPitch:
        "Ordentligt håndværk, god dialog og løsninger, du bliver glad for i længden.",
    availabilityNote: "Ledige tider lige nu",
    badge: "100 % anbefalet på Facebook · 5 anmeldelser",
    portrait:
        "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/v3b3k11s_617019751_122112533721146607_5490896281630066587_n.jpg",
    heroImage:
        "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/9jwxkju6_618370268_122112718899146607_6082479463642854861_n.jpg",
    logo: "https://customer-assets.emergentagent.com/job_tomrer-nicklas/artifacts/6r2vdcgs_Ns%20t%C3%B8mrer%20Logo.jpg",
};
